import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6814c65d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6814c65d&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6814c65d')) {
      api.createRecord('6814c65d', component.options)
    } else {
      api.reload('6814c65d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6814c65d", function () {
      api.rerender('6814c65d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/quotations/index.vue"
export default component.exports